<!-- App.vue -->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
